import request from '@/utils/request'
export const getBadluckRanking = (id) => {
  return request.get(`/badluckrankings/${id}`)
}

// badLuckRankingList是一个包含pageNo和pageSize的对象
export const getBadluckRankingList = (badLuckRankingList) => {
  return request.get('/badluckrankings/list', {
    params: badLuckRankingList
  })
}

export const getCombatRanking = (id) => {
  return request.get(`/combatrankings/${id}`)
}

// combatRankingList
export const getCombatRankingList = (combatRankingList) => {
  return request.get('/combatrankings/list', {
    params: combatRankingList
  })
}
export const updateCombatRankingList = (combatRankingList) => {
  return request.put('/combatrankings', combatRankingList)
}
export const addCombatRankingList = (combatRankingList) => {
  return request.post('/combatrankings', combatRankingList)
}

export const getOldCombatRankingList = (oldCombatRankingList) => {
  return request.get('/oldcombatranking/list', {
    params: oldCombatRankingList
  })
}

export const getCommercialMemberRanking = (id, userId) => {
  if (userId != null) {
    return request.get(`/commercialmemberrankings/${id}?userId=${userId}`)
  }
  return request.get(`/commercialmemberrankings/${id}`)
}

// badLuckRankingList是一个包含pageNo和pageSize的对象
export const getCommercialMemberRankingList = (commercialMemberRanking) => {
  return request.get('/commercialmemberrankings/list', {
    params: commercialMemberRanking
  })
}
export const changeCommercialLike = (commercialMemberId) => {
  return request.put(`/commercialmemberrankings/like?commercialMemberId=${commercialMemberId}`)
}
export const getCommercialMemberInfo = (id) => {
  return request.get('/commercialmemberrankings', {
    params: { id }
  })
}
export const addCommercialMemberRanking = (commercialMember) => {
  return request.post('/commercialmemberrankings', commercialMember)
}
// 由于get接口被占用了，所以此处将get请求改为post
export const getMyCommercialMember = () => {
  return request.post('/commercialmemberrankings/my')
}

export const updateCommercialMemberRankingList = (commercialMember) => {
  return request.put('/commercialmemberrankings', commercialMember)
}
export const getCreditsRanking = (id) => {
  return request.get(`/creditsrankings/${id}`)
}

// badLuckRankingList是一个包含pageNo和pageSize的对象
export const getCreditsRankingList = (creditsRankingList) => {
  return request.get('/creditsrankings/list', {
    params: creditsRankingList
  })
}

export const getExpenseRanking = (id) => {
  return request.get(`/expenserankings/${id}`)
}

// badLuckRankingList是一个包含pageNo和pageSize的对象
export const getExpenseRankingList = (expenseRankingList) => {
  return request.get('/expenserankings/list', {
    params: expenseRankingList
  })
}

export const getGoodluckRanking = (id) => {
  return request.get(`/goodluckrankings/${id}`)
}

// badLuckRankingList是一个包含pageNo和pageSize的对象
export const getGoodluckRankingList = (goodluckRankingList) => {
  return request.get('/goodluckrankings/list', {
    params: goodluckRankingList
  })
}

export const getOutfitRanking = (id) => {
  return request.get(`/outfitrankings/${id}`)
}

// badLuckRankingList是一个包含pageNo和pageSize的对象
export const getOutfitRankingList = (outfitRankingList) => {
  return request.get('/outfitrankings/list', {
    params: outfitRankingList
  })
}
export const getMyOutfits = (pageNo, pageSize) => {
  return request.get('/outfitrankings', {
    params: {
      pageNo,
      pageSize
    }
  })
}
export const deleteOutfits = (outfitsId) => {
  const outfitIds = outfitsId.join(',')
  return request.delete('/outfitrankings', {
    params: {
      outfitIds
    }
  }
  )
}
export const addOutfit = (outfit) => {
  return request.post('/outfitrankings', outfit)
}
export const updateOutfit = (outfit) => {
  return request.put('/outfitrankings', outfit)
}
export const getRichestRanking = (id) => {
  return request.get(`/richestrankings/${id}`)
}

// badLuckRankingList是一个包含pageNo和pageSize的对象
export const getRichestRankingList = (richestRankingList) => {
  return request.get('/richestrankings/list', {
    params: richestRankingList
  })
}

// badLuckRankingList是一个包含pageNo和pageSize的对象
export const getDonatorRankingList = (donatorRankingList) => {
  return request.get('/donator/list', {
    params: donatorRankingList
  })
}
